(function () {
  if (!('IntersectionObserver' in window)) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  // A partir del quinto hijo el retardo ya no crece: si no, la cascada se hace tan larga
  // que el ultimo elemento entra mucho despues de que el usuario dejo de mirar.
  var STAGGER_CAP = 3;

  // .t4s-section-inner lo traen las secciones del tema; data-scroll-reveal es el enganche
  // para las secciones propias que no lo tienen.
  var ROOT_SELECTOR = '.t4s-section-inner, [data-scroll-reveal]';

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, LINK: 1, NOSCRIPT: 1 };

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);

        // Se oculta aqui y no al cargar: asi lo que nunca llega a entrar en pantalla
        // -- el bottom-bar movil, que va display:none en desktop -- jamas se queda en
        // opacity 0, y no hace falta adivinar de antemano quien es visible.
        entry.target.classList.add('scroll-animate');
        prepareItems(entry.target);

        // Dos cuadros: uno para que el navegador pinte el estado oculto y otro para
        // arrancar la transicion. En el mismo cuadro no habria animacion, solo un salto.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            entry.target.classList.add('is--revealed');
          });
        });
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -5% 0px'
    }
  );

  // Un slider mueve sus propias celdas: escalonarlas por fuera pelea con su transform y
  // deja huecos mientras entra. En esos casos se anima el bloque completo.
  var SLIDER_SELECTOR = '[data-flickity], .flickityt4s-enabled, .swiper, [data-swiper], .t4s-flicky-slider';

  function tieneAncestroFijo(el) {
    var actual = el;
    while (actual && actual !== document.body) {
      var cs;
      try { cs = getComputedStyle(actual); } catch (e) { return false; }
      if (cs.position === 'fixed') return true;
      actual = actual.parentElement;
    }
    return false;
  }

  function hijosUtiles(el) {
    var out = [];
    for (var i = 0; i < el.children.length; i++) {
      if (!SKIP_TAGS[el.children[i].tagName]) out.push(el.children[i]);
    }
    return out;
  }

  // Reparte el escalonado entre los hijos del contenedor. Son ellos los que se mueven;
  // el contenedor solo marca cuando disparar.
  function prepareItems(root) {
    var items = hijosUtiles(root);

    // Casi todas las secciones del tema envuelven su contenido en uno o varios divs
    // encadenados, y con un solo elemento no hay cascada que ver. Se atraviesan esos
    // eslabones de hijo unico buscando el primer nivel con hermanos de verdad. Tope de
    // 3 saltos para no acabar escalonando parrafos sueltos.
    var cursor = items;
    var saltos = 0;
    while (cursor.length === 1 && saltos < 3) {
      if (cursor[0].matches && cursor[0].matches(SLIDER_SELECTOR)) break;
      var dentro = hijosUtiles(cursor[0]);
      if (!dentro.length) break;
      cursor = dentro;
      saltos++;
      // Solo se adopta el nivel nuevo si aporta hermanos; si no, se sigue bajando y en
      // el peor caso queda el nivel de arriba, que es el comportamiento anterior.
      if (cursor.length > 1) {
        items = cursor;
        break;
      }
    }

    // Contenedor sin hijos aprovechables: se anima entero, como hacia la version anterior.
    if (!items.length) items = [root];

    items.forEach(function (item, index) {
      item.classList.add('scroll-animate__item');
      item.style.setProperty('--reveal-i', Math.min(index, STAGGER_CAP));

      if (item.getBoundingClientRect().width >= window.innerWidth * 0.98) {
        item.style.setProperty('--reveal-scale', '1');
      }
    });
  }

  function observeSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(ROOT_SELECTOR).forEach(function (el) {
      if (el.classList.contains('scroll-animate') || el.dataset.revealObservado) return;
      el.dataset.revealObservado = '1';

      // Varias secciones anidan un .t4s-section-inner dentro de otro. querySelectorAll
      // devuelve en orden de documento, asi que al llegar al de dentro el de fuera ya
      // esta marcado y lo descartamos: si no, el contenido hacia doble fade.
      if (el.parentElement && el.parentElement.closest('.scroll-animate')) return;

      // El chrome fijo -- header pegado, barra inferior, popups -- no se revela con el
      // scroll: aparece y desaparece por su cuenta, y un fade lo dejaria a medias.
      if (tieneAncestroFijo(el)) return;

      // Ya visible al cargar: se deja intacto, sin clases ni ocultado. Animar lo que el
      // usuario ya tiene delante solo produce un parpadeo.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeSections();
    });
  } else {
    observeSections();
  }

  document.addEventListener('shopify:section:load', function (e) {
    observeSections(e.target);
  });
})();
